import { HoloPulse } from '@/components/ui/holo-pulse';

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <HoloPulse />
  </div>
);

export default PageLoader;
